import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { fetchObterNfse } from '../api/ObterNfseApi';
import type { ObterNfseResponse } from '../types';

export function useObterNfse(
  chaveAcessoDoc?: string | null,
  cnpjContribuinte?: string | null,
  options?: Omit<UseQueryOptions<ObterNfseResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();

  const query = useQuery<ObterNfseResponse, Error>({
    queryKey: ['servicos-nfse-detalhe', chaveAcessoDoc, cnpjContribuinte ?? null],
    queryFn: () => fetchObterNfse(chaveAcessoDoc as string, cnpjContribuinte),
    staleTime: 5 * 60 * 1000,
    ...options,
    enabled: (options?.enabled ?? true) && !!chaveAcessoDoc,
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar detalhes da NFS-e',
      description:
        query.error.message || 'Não foi possível carregar os detalhes da NFS-e. Tente novamente.',
    });
  }, [query.error, toast]);

  return query;
}
